import Flickity from 'flickity-fade';

function initTrustIndicators(container) {
  const trustIndicatorsSlider = container.querySelector('.trust-indicators__slider');

  if (!trustIndicatorsSlider) return;

  // eslint-disable-next-line no-unused-vars
  const flickity = new Flickity(trustIndicatorsSlider, {
    prevNextButtons: false,
    pageDots: false,
    fade: true,
    autoPlay: true,
  });
}

export default initTrustIndicators;
